"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var useStyles = (0, core_1.makeStyles)(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        root: {
            '& > div, & > label, & input': {
                fontSize: typography.caption.fontSize
            }
        },
        active: {
            '& > div:after': {
                transform: 'scaleX(1)'
            }
        },
        required: {
            color: palette.error.main,
            fontSize: typography.body2.fontSize,
            lineHeight: 0.8
        }
    });
});
var TextField = function (_a) {
    var _b;
    var _c = _a.classes, classes = _c === void 0 ? {} : _c, autoComplete = _a.autoComplete, _d = _a.autoFocus, autoFocus = _d === void 0 ? false : _d, children = _a.children, _e = _a.color, color = _e === void 0 ? 'primary' : _e, defaultValue = _a.defaultValue, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.error, error = _g === void 0 ? false : _g, FormHelperTextProps = _a.FormHelperTextProps, _h = _a.fullWidth, fullWidth = _h === void 0 ? false : _h, helperText = _a.helperText, id = _a.id, InputLabelProps = _a.InputLabelProps, inputRef = _a.inputRef, _j = _a.label, label = _j === void 0 ? null : _j, margin = _a.margin, _k = _a.multiline, multiline = _k === void 0 ? false : _k, name = _a.name, placeholder = _a.placeholder, onChange = _a.onChange, _l = _a.required, required = _l === void 0 ? false : _l, rows = _a.rows, rowsMax = _a.rowsMax, _m = _a.select, select = _m === void 0 ? false : _m, SelectProps = _a.SelectProps, size = _a.size, type = _a.type, value = _a.value, _o = _a.variant, variant = _o === void 0 ? 'standard' : _o, inputProps = _a.inputProps, InputProps = _a.InputProps;
    var internalClasses = useStyles();
    var requiredSymbol = (react_1.default.createElement("span", { className: internalClasses.required }, "\u2009*"));
    var dataLabel = (react_1.default.createElement(react_1.default.Fragment, null,
        label,
        required ? requiredSymbol : ''));
    return (react_1.default.createElement(TextField_1.default, { classes: __assign(__assign({}, classes), { root: (0, classnames_1.default)('textField', (_b = {},
                _b[internalClasses.active] = value,
                _b[internalClasses.root] = true,
                _b[classes.root || ''] = true,
                _b)) }), autoComplete: autoComplete, autoFocus: autoFocus, color: color, defaultValue: defaultValue, disabled: disabled, error: error, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth, helperText: helperText, id: id, InputLabelProps: InputLabelProps, inputRef: inputRef, label: label && dataLabel, margin: margin, multiline: multiline, name: name, placeholder: placeholder, onChange: onChange, rows: rows, rowsMax: rowsMax, select: select, SelectProps: SelectProps, size: size, type: type, value: value, variant: variant, InputProps: InputProps, 
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps: inputProps }, children));
};
exports.default = TextField;
